import { z } from 'zod';
/**
 * Nhắc bấm giờ đầu ca qua Telegram — APM-TREM, docs/plan-timer-reminder.md.
 *
 * Admin tổ chức chọn **vai trò tổ chức** nào nhận nhắc và loại trừ từng người
 * không chấm công theo giờ chuẩn. Người dùng chốt 2026-10-19: chỉ vai trò tổ
 * chức, không cấu hình theo vai trò dự án; mặc định chỉ Nhân viên.
 */
/**
 * Vai trò chọn được. Chỉ vị trí thật: `ORG_ADMIN` là cờ `is_org_admin` từ
 * APM-OADM-a (không phải vị trí), còn `SUPER_ADMIN` là người vận hành hệ thống.
 */
export const TIMER_REMINDER_ROLES = ['DIRECTOR', 'LEADER', 'EMPLOYEE'];
export const TimerReminderRole = z.enum(TIMER_REMINDER_ROLES);
/** Trần người loại trừ — đủ cho mọi tổ chức thật, chặn một thân request vô hạn. */
export const MAX_TIMER_REMINDER_EXCLUDED = 500;
/** Nhắc muộn nhất 60 phút sau đầu ca; muộn hơn thì lời nhắc không còn ích gì. */
export const MAX_TIMER_REMINDER_DELAY_MINUTES = 60;
export const TimerReminderConfig = z.object({
    enabled: z.boolean(),
    roles: z.array(TimerReminderRole),
    excludedUserIds: z.array(z.uuid()),
    delayMinutes: z.number().int().min(0).max(MAX_TIMER_REMINDER_DELAY_MINUTES),
});
/** Chưa có hàng cấu hình thì dùng đúng giá trị này — khớp `DEFAULT` của cột. */
export const DEFAULT_TIMER_REMINDER = {
    enabled: true,
    roles: ['EMPLOYEE'],
    excludedUserIds: [],
    delayMinutes: 10,
};
export const UpdateTimerReminderInput = z.object({
    enabled: z.boolean(),
    roles: z
        .array(TimerReminderRole)
        .max(TIMER_REMINDER_ROLES.length)
        .refine((roles) => new Set(roles).size === roles.length, 'Vai trò bị lặp'),
    excludedUserIds: z
        .array(z.uuid())
        .max(MAX_TIMER_REMINDER_EXCLUDED)
        .refine((ids) => new Set(ids).size === ids.length, 'Người loại trừ bị lặp'),
    delayMinutes: z.number().int().min(0).max(MAX_TIMER_REMINDER_DELAY_MINUTES),
});
//# sourceMappingURL=timer-reminder.js.map